import type { WordLimit } from "@memorang/types";
import { useDevice } from "../../../../useDevice";
import Box from "../../../Box";
import useWritingTimer from "../../hooks/useWritingTimer";
import WritingInput from "../WritingInput";
import { ItemInstruction } from "./pte/ItemInstruction";
import { ItemStemCard } from "./pte/ItemStemCard";

type Props = {
	stem: string;
	instruction: string;
	value?: string;
	onChangeText: (value: string) => void;
	disabled?: boolean;
	wordLimit?: WordLimit;
	timeLimit?: number;
	initialElapsedSeconds?: number;
	onResponseComplete?: () => void;
};

const WriteEmail = ({
	stem,
	instruction,
	value,
	onChangeText,
	disabled,
	wordLimit,
	timeLimit,
	initialElapsedSeconds,
	onResponseComplete,
}: Props) => {
	const { isMobile } = useDevice();
	const writingTimer = useWritingTimer({
		timeLimit,
		startTrigger: "mount",
		disabled,
		initialElapsedSeconds,
		onExpire: onResponseComplete,
	});

	return (
		<Box gap={isMobile ? 16 : 24}>
			<ItemInstruction instruction={instruction} />
			<ItemStemCard text={stem} userSelect="text" />
			<Box gap={8}>
				<WritingInput
					value={value}
					onChangeText={onChangeText}
					disabled={disabled || writingTimer.isExpired}
					isAnswered={disabled}
					wordLimit={wordLimit}
					autoExpand
					showWordLimitError={false}
				/>
			</Box>
		</Box>
	);
};

export default WriteEmail;
